<template>
  <!-- Landing -->
  <div :style="{overflow: 'hidden'}">
    <h1 class="is-size-2 is-size-2-touch domain-heading has-text-centered is-uppercase">
      <p v-html="$t('domains.tips.heading')" />
    </h1>
    <div class="columns is-multiline domain-tips">
      <domain-tip
        :title="$t('domains.tips.keep_short.title')"
        :tip="$t('domains.tips.keep_short.description')"
      />
      <domain-tip
        :title="$t('domains.tips.say_loud.title')"
        :tip="$t('domains.tips.say_loud.description')"
      />
      <domain-tip
        :title="$t('domains.tips.geographic.title')"
        :tip="$t('domains.tips.geographic.description')"
      />
      <domain-tip
        :title="$t('domains.tips.memorable.title')"
        :tip="$t('domains.tips.memorable.description')"
      />
      <!-- <domain-tip
        :title="$t('domains.tips.alt_spellings.title')"
        :tip="$t('domains.tips.alt_spellings.description')"
      />
      <domain-tip
        :title="$t('domains.tips.alt_extensions.title')"
        :tip="$t('domains.tips.alt_extensions.description')"
      /> -->
    </div>
  </div>
</template>

<script>
import DomainTip from './DomainTip'

export default {

  name: 'DomainTips',
  components: {
    DomainTip
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';

.domain-heading {
  color: var(--tertiary-color);
  font-weight: 300;
  font-size: 44px;
  letter-spacing: -0.506496px;
  padding: 15px;
  width: 100%;
  margin-top: 15px;
  margin-bottom: 0px;
}
.domain-tips {
  padding: 20px;
  color: $medium-grey;
}

.colums {
  margin: 0;
}
</style>
